export default "__VITE_ASSET__DgXMtX0l__"